/**
 * Do not edit directly
 * Generated on Thu, 19 Aug 2021 21:48:11 GMT
 */
export const IconXs = "16px";
export const IconS = "18px";
export const IconM = "24px";
export const IconL = "28px";
export const IconXl = "32px";
export const IconXxl = "48px";
